import React from 'react';
import Icon from '../../../components/AppIcon';

const RedeemModal = ({ redemption, userPoints, onConfirm, onCancel }) => {
  const remainingPoints = userPoints - redemption?.pointCost;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-16">
      <div 
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onCancel}
      />
      
      <div className="relative bg-card rounded-lg shadow-elevation-5 w-full max-w-md p-24 md:p-32">
        <div className="flex items-center justify-between mb-24">
          <h2 className="text-2xl font-heading font-semibold text-secondary">
            Confirm Redemption
          </h2>
          <button
            onClick={onCancel}
            className="p-8 hover:bg-muted rounded-lg transition-smooth"
          >
            <Icon name="X" size={20} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="mb-24">
          <div className="bg-primary/5 rounded-lg p-20 mb-20">
            <h3 className="text-lg font-heading font-semibold text-card-foreground mb-8">
              {redemption?.title}
            </h3>
            <p className="text-sm text-muted-foreground mb-16">
              {redemption?.description}
            </p>
            <div className="flex items-center gap-6">
              <Icon name="Coins" size={18} color="var(--color-primary)" />
              <span className="text-xl font-heading font-bold text-primary">
                {redemption?.pointCost?.toLocaleString()} points
              </span>
            </div>
          </div>

          <div className="space-y-12">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Current Balance</span>
              <span className="text-base font-heading font-semibold text-card-foreground">
                {userPoints?.toLocaleString()} points
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Cost</span>
              <span className="text-base font-heading font-semibold text-destructive">
                -{redemption?.pointCost?.toLocaleString()} points
              </span>
            </div>
            <div className="border-t border-border pt-12">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-card-foreground">Remaining Balance</span>
                <span className="text-lg font-heading font-bold text-success">
                  {remainingPoints?.toLocaleString()} points
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-accent/5 rounded-lg p-16 mb-24">
          <div className="flex items-start gap-12">
            <Icon name="Info" size={18} color="var(--color-accent)" className="flex-shrink-0 mt-2" />
            <p className="text-sm text-muted-foreground">
              This redemption will be processed immediately and cannot be undone. The benefit will be applied to your account.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-12">
          <button
            onClick={onCancel}
            className="flex-1 px-16 py-12 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-smooth font-medium min-h-[44px]"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-16 py-12 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-smooth font-medium min-h-[44px] flex items-center justify-center gap-8"
          >
            <Icon name="Check" size={16} />
            Confirm Redemption
          </button>
        </div>
      </div>
    </div>
  );
};

export default RedeemModal;